<kendo-expansionpanel [title]="'Assigned Reps'"
                      [subtitle]=""
                      [expanded]="true">
    <div class="row" *ngIf="carrierRepsAssignedAvailable.length>0">
        <div class="col">
            <kendo-grid [data]="carrierRepsAssignedAvailableView"
                        [height]="400"
                        [pageable]="false"
                        [filterable]="true"
                        [filter]="carrierRepsAssignedAvailableState.filter"
                        (dataStateChange)="carrierRepsAssignedAvailableStateChange($event)">
                <kendo-grid-column title="Assigned" width="75">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                               id="rep{{ dataItem.csrEmployeeId }}"
                               name="rep{{ dataItem.csrEmployeeId }}"
                               (change)="setCarrierRepsAssigned(dataItem)"
                               [checked]="dataItem.quoteOrderLineID>0"
                               autocomplete="off" />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="csrEmployeeName" title="Carrier Rep" width="200"></kendo-grid-column>
            </kendo-grid>

            <!--<input type="button"
                   *ngFor="let line of quoteOrderLines"
                   class="btn btn-primary m-2"
                   value="Leg #{{line.legNumber}}"
                   (click)="getCarrierRepsAvailable(line.quoteOrderLineID)" />
            <br />-->
            <!--<kendo-multiselect [data]="carrierReps"
                               textField="fullName"
                               valueField="employeeId"
                               [autoClose]="false"
                               [valuePrimitive]="true"
                               [value]="selectedCarrierReps"
                               (valueChange)="carrierRepsChange($event)">
            </kendo-multiselect>-->
            <!--<div *ngFor="let rep of carrierReps" style="display:inline-block;width:33%;">
                <input type="checkbox" id="rep{{ rep.employeeId }}" style="margin: 5px; transform: scale(1.5);" />
                <label for="rep{{ rep.employeeId }}">{{ rep.fullName }}</label>
            </div>-->
        </div>
        <!--<div class="col-sm-12 text-end align-self-end">
            <input type="button" class="btn btn-primary" value="Save Assigned Reps" (click)="saveAllCarrierRepsAssigned()" />
        </div>-->
    </div>
</kendo-expansionpanel>
